import * as React from "react";
import { forwardRef } from "react";
const LinkCheckSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fill: "#09AB8B", d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12" }),
    React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M18.669 6.159a1 1 0 0 1 .074 1.412l-9 10a1 1 0 0 1-1.459.029l-3-3.077a1 1 0 1 1 1.432-1.396l2.255 2.313 8.286-9.207a1 1 0 0 1 1.412-.074", clipRule: "evenodd" }));
const ForwardRef = forwardRef(LinkCheckSVG);
export default ForwardRef;
//# sourceMappingURL=LinkCheck.js.map